






















// 3rd Party
import {
    PropType,
} from 'vue';

// Helpers
import {
    isNumber,
} from '@shared/utils/dom';

type CustomRange = {
    min?: string;
    max?: string;
};

export default {
    props: {
        direction: {
            type: String as PropType<'column' | 'row'>,
            default: 'column',
        },
        selectedRange: {
            type: Object as PropType<CustomRange>,
            default: () => ({
                min: '',
                max: '',
            }),
        },
    },
    data() {
        return {
            customRange: {} as CustomRange,
        };
    },
    computed: {
        isCustomMinInvalid(): boolean {
            const {
                min,
                max,
            } = this.customRange;

            return Boolean(max && Number(min) > Number(max));
        },
    },
    watch: {
        selectedRange: {
            immediate: true,
            handler(range: CustomRange) {
                this.customRange = range;
            },
        },
    },
    methods: {
        isNumber,

        handleRange(): void {
            if (this.isCustomMinInvalid) {
                return;
            }

            this.$emit('change', {
                range: this.customRange,
                text: this.getText(this.customRange),
            });
        },

        getText({
            min,
            max,
        }: CustomRange): string {
            if (max && min) {
                return `${min}-${max}`;
            }

            if (min) {
                return `${min}+`;
            }

            return `0-${max}`;
        },
    },
};
